module.exports = __webpack_public_path__ + "static/image/history/m/202204@3x.ver2_0_2.jpg?91214325";